import { PersonaDetailDto } from "@models/personas/personaDetailDto.model"
import { BaseDto } from "../base/baseDto.model"
import { CuentaContableDto } from "../cuentas-contables/cuentaContableDto.model"

export class PersonaCuentaContableDto extends BaseDto{
  public cuentaContable: CuentaContableDto = new CuentaContableDto
  public persona: PersonaDetailDto = new PersonaDetailDto
  public activo: boolean = false
}
